import React from "react";

import { BrowserRouter, Route, Switch } from "react-router-dom";
import { QqPageRawComponent } from "./components/page/qq.page-raw";
import { QqPageComponent } from "./components/page/qq.page";

import { vmDecision } from "./data/vm-decision.data";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/raw"
          component={() => <QqPageRawComponent questions={vmDecision()} />}
        />
        <Route
          path="/"
          component={() => <QqPageComponent questions={vmDecision()} />}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
